import classNames from 'classnames';
import React from 'react';
import { Mask } from './mask';

const Panel: React.FC<React.PropsWithChildren<{ isShowPanel?: boolean }>> = ({ children, isShowPanel = true }) => {
    return (
        <div className={classNames('p-editor__panel', { active: isShowPanel })}>
            {children}
            <Mask type="panel" />
        </div>
    );
};

export default Panel;
